/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function MatchHeight() {
  $('.SidebarMenu__Nav .Linklist .Linklist__Item img').matchHeight({});
  $('.SidebarMenu__Nav .coll-menu-img img').matchHeight({});
}

// 12 nov 2025 start
$(document).ready(function() {
  if($('.add-to-cart-sticky-container').length > 0) {   
    $('.add-to-cart-sticky-container').on('click', '.add-to-cart-sticky-button', function(e) {
      e.preventDefault();
      $('button[data-action="add-to-cart"]').click();
    });
  }

  document.addEventListener('scroll', function() {
    if(window.scrollY > window.innerHeight - 100) {
      $('.add-to-cart-sticky-container').removeClass('js-hidden');
      $('body').addClass('add-to-cart-sticky-container-visible');
    } else {
      $('.add-to-cart-sticky-container').addClass('js-hidden');
      $('body').removeClass('add-to-cart-sticky-container-visible');
    }
  });
});
// 12 nov 2025 end

$(document).ready(function () {

  MatchHeight();
  (document.querySelectorAll('img.svg').forEach(function (img) {
    var imgID = img.id;
    var imgClass = img.className;
    var imgURL = img.src;

    fetch(imgURL).then(function (response) {
      return response.text();
    }).then(function (text) {

      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(text, "text/xml");

      // Get the SVG tag, ignore the rest
      var svg = xmlDoc.getElementsByTagName('svg')[0];

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        svg.setAttribute('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        svg.setAttribute('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      svg.removeAttribute('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if (!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
        svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'))
      }

      // Replace image with new SVG
      img.parentNode.replaceChild(svg, img);

    });

  }))();

});


$(document).ready(function () {
  $(".HorizontalList > .HorizontalList__Item").mouseover(function () {
    $('.Header').addClass('header-filled');
  });
  $(".HorizontalList > .HorizontalList__Item").mouseout(function () {
    $('.Header').removeClass('header-filled');
  });
  $('#section-header').mouseover(function () {
    $('.Header').addClass('header-filled');
  });
  $('#section-header').mouseout(function () {
    $('.Header').removeClass('header-filled');
  });
})

// 18 may 2022 start//
$('.slider_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider_nav',
  accessibility: false,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        cssEase: 'linear',
        speed: 500,
        asNavFor: '.slider_nav',
      }
    }
  ]
});
$('.slider_nav').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: '.slider_for',
  dots: false,
  arrows: false,
  infinite: false,
  focusOnSelect: true,
  accessibility: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 1,
        centerMode: false,
        speed: 1000,
      }
    }
  ]
});



jQuery(function ($) {
  $('.modal').on('shown.bs.modal', function (e) {
    if($('.sliderforproduct.slick-slider').length == 0) {
      $('.sliderforproduct').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0196/5893/2324/files/suit-next-arrow.svg?v=1729000358"></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0196/5893/2324/files/suit-prev-arrow.svg?v=1729000358"></button>',
        infinite: false,
        fade: true,
        asNavFor: '.slidernavproduct'
      });
  
      $('.slidernavproduct').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.sliderforproduct',
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: false,
            }
          }
        ]
      });
    }
  });

  $(document).on('click','.slider_nav .item',function (e) {
    e.preventDefault();
    var dataslide = $(this).data('slide');
    setTimeout(function () {
      $('.slidernavproduct').slick('slickGoTo', dataslide - 1);
    },500);
  });
    $(document).on('click','.slider_for .item',function (e) {
    e.preventDefault();
    var dataslide = $(this).data('slide');
    setTimeout(function () {
      $('.slidernavproduct').slick('slickGoTo', dataslide - 1);
    },500);
  });
});

// 19 july 2022 start//
$('.mob-customize-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: '.mob-customize-nav',
  accessibility: false,
});

// get number of slides in mob-customize-for
var numSlides = $('.mob-customize-for').slick('getSlick').slideCount;
console.log(numSlides);

$('.mob-customize-nav').slick({
  slidesToShow: numSlides,
  variableWidth: false,
  draggable: true,
  slidesToScroll: 1,
  asNavFor: '.mob-customize-for',
  dots: false,
  arrows: false,
  infinite: false,
  focusOnSelect: false,
  accessibility: false,

});

$(document).ready(function() {
  var count = $('.Grid__Cell .size-variant-selector__heading').children('.labelall').length
  console.log(count);
    $(document).on('click','.productclick',function(e){
      e.preventDefault();
      var a = $(this).attr('class').split(' ');
      a.forEach( (em,ix) => {
        if( em.toString().indexOf('cc-') !== -1 ){
          a[2] = em.toString();
          return false;
        }
      });
    var b =a[2].split('cc-');
     console.log (b[1]);
        var image = $(this).attr('data-images');
        var url =$(this).attr('data-product-url');
   var secondim =$(this).attr('data-second-img');
   $(".ttt-"+b[1]).attr("src", image);
  $('.changeurl-'+b[1]).attr('href', url);
  $('.gg-'+b[1]).attr('src', secondim);
  $('.cc-'+b[1]+'.active').removeClass('active');
    $(this).addClass('active');
       }); 
        $(document).on('click','.plusvar',function(e){
        e.preventDefault();
         //$('.allprouct').show(); 
          var id = $(this).attr('dataid');
   $(".cc-"+id).show();
   $(".plus-"+id).hide(); 
    });
    }); 


/* 17-11-2022 */ 
$(document).ready(function() {
  $(".mobileimage").each(function(index) {
    $(this).height($(this).next().find('.ProductItem').height());
  });
  $(".desktopimage").each(function(index) {
    $(this).height($(this).next().height());
  });

  /* 21-11-2022 pri */
  $(".desktopvideo").each(function(index) {
    $(this).height($(this).prev().find('.ProductItem').height());
  });

   $(".mobile-video").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
  });
  
  $(window).on('resize',function() {
    $(".mobileimage").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
      console.log($(this).next().find('.ProductItem').height());
    });
    $(".desktopimage").each(function(index) {
      $(this).height($(this).next().height());
    });

    /* 21-11-2022 pri */
     $(".mobile-video").each(function(index) {
      $(this).height($(this).next().find('.ProductItem').height());
  });
    /* 23-11-2022 pri*/
      $(".desktopvideo").each(function(index) {
        $(this).height($(this).prev().find('.ProductItem').height());
      });
  })
})